/**
 * @fileoverview Shared Area schema used by both frontend and backend.
 */

import { z } from 'zod';
import { createCrudSchemas, createDisplayableEntitySchema, getSchemaFields } from './base.js';
import { ID_PATTERNS } from './types.js';

export const AreaSchema = createDisplayableEntitySchema(
  ID_PATTERNS.AREA,
  'ID must be in ar-prefixed nanoid7 format',
  { archivable: true, accountTracking: 'archivable' }
);

const { CreateSchema, UpdateSchema } = createCrudSchemas(AreaSchema);

export const AreaCreateSchema = CreateSchema;
export const AreaUpdateSchema = UpdateSchema;

export type Area = z.infer<typeof AreaSchema>;
export type AreaCreate = z.infer<typeof AreaCreateSchema>;
export type AreaUpdate = z.infer<typeof AreaUpdateSchema>;

export const AREA_FIELDS = getSchemaFields(AreaSchema);
